import React from 'react'
import { NavLink as Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const BLink = ({ url, count, name, linkGap }) => (
  <Link
    to={url}
    exact
    className={`flex items-center lg:${linkGap} p-3`}
    activeClassName="text-primary-orange border-b-2 border-primary-orange"
  >
    <span>{name}</span>
    {count > 0 && (
      <span className="count ml-2 text-xs text-white rounded-full bg-blue-600 w-5 h-5 text-center">
        {count}
      </span>
    )}
  </Link>
)

BLink.propTypes = {
  url: PropTypes.string,
  count: PropTypes.number,
  name: PropTypes.string,
  linkGap: PropTypes.string,
}

export default BLink
